(function(angular) {
    'use strict';

    angular.module('wtApp.wtCommon').service('wtColor', wtColor);
    wtColor.$inject = [];

    function wtColor() {
        /**
         * Converts a RGB string to a hex string
         * @param {String} rgb
         */
        return {
            rgb2hex: function(iRGB) {
                var rgb = iRGB;
                // ie fix, here comes color already  as hex value
                if (!rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)) {
                    return rgb;
                }

                rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

                return '#' + ('0' + parseInt(rgb[1]).toString(16)).slice(-2)
                    + ('0' + parseInt(rgb[2]).toString(16)).slice(-2)
                    + ('0' + parseInt(rgb[3]).toString(16)).slice(-2);
            },

            /**
             * Solution was taken from
             * https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
             * and slightly changed in order to make it a bit more readable.
             * Changes brightness of a hex color by a percentual value
             * @param {string} color
             * @param {number} ratio
             * @param {number} iDarker
             * @returns {*|string}
             */
            /* eslint-disable */
            changeColor: function(color, ratio) {
                const oldColorValue = parseInt(color.slice(1), 16);
                const target = ratio < 0 ? 0 : 255;
                const p = ratio < 0 ? ratio * -1 : ratio;
                const R = oldColorValue >> 16;
                const G = oldColorValue >> 8 & 0x00FF;
                const B = oldColorValue & 0x0000FF;

                function applyRatio(oldColor) {
                    return Math.round((target - oldColor) * p) + oldColor;
                }

                const colorValue = (0x1000000 + applyRatio(R) * 0x10000 + applyRatio(G) * 0x100 + applyRatio(B));
                return '#' + colorValue.toString(16).slice(1);
            },
            /* eslint-enable */

            lighterColor: function(color, ratio) {
                return this.changeColor(color, ratio);
            },

            darkerColor: function(color, ratio) {
                return this.changeColor(color, ratio * -1);
            }
        };
    }
})(window.angular);
